import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { RouterProvider } from "@tanstack/react-router"
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools"

import { router } from "./router"
import { ApiError } from "./lib/api"
import { ConfirmProvider, ToastProvider } from "./components/feedback"
import "./styles/globals.css"

const root = document.getElementById("root")
if (!root) throw new Error("Missing application root")

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => error instanceof ApiError ? error.status >= 500 && failureCount < 1 : failureCount < 1,
    },
  },
})

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfirmProvider>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </ConfirmProvider>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      {import.meta.env.DEV && <TanStackRouterDevtools router={router} />}
    </QueryClientProvider>
  </StrictMode>
)
